export const ROOM_CALL_FOR_IMPACT = 'call_for_impact';
export const ROOM_THEME_TABLE = 'theme_table';



// WEBPACK FOOTER //
// ./src/constants/rooms.js